import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { auth } from '../firebase';
import { getUserProfile, createUserProfile } from '../services/expenseFirestore';
import { toast } from 'react-toastify';
import logo from '../assets/logos/WHITE Logo Text PNG.png';
import './Login.css';

export default function Login() {
  const [loginType, setLoginType] = useState(null);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const cred = await signInWithEmailAndPassword(auth, email, password);
      const profile = await getUserProfile(cred.user.uid);
      const expected = loginType === 'admin' ? 'admin' : 'employee';

      if (!profile) {
        await signOut(auth);
        toast.error('No user profile found in database. Please contact an administrator.');
        setLoading(false);
        return;
      }

      const role = profile.role;

      if (role !== expected) {
        await signOut(auth);
        toast.error(`This account is not registered as ${loginType}.`);
        setLoading(false);
        return;
      }

      toast.success('Login successful!');
      const from = location.state?.from?.pathname;
      if (role === 'employee') {
        navigate(from && from.startsWith('/employee') ? from : '/employee', { replace: true });
      } else {
        navigate(from && from.startsWith('/dashboard') ? from : '/dashboard', { replace: true });
      }
    } catch (error) {
      console.error('Login error:', error);
      toast.error(error.message || 'Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  if (loginType) {
    return (
      <div className="login-page">
        <div className="login-page-card">
          <button type="button" className="login-back" onClick={() => setLoginType(null)}>
            <i className="fas fa-arrow-left" /> Back
          </button>
          <img src={logo} alt="TVC" className="login-page-logo" />
          <p className="login-eyebrow">{loginType === 'admin' ? 'Admin Console' : 'Employee Portal'}</p>
          <h1>{loginType === 'admin' ? 'Admin Login' : 'Employee Login'}</h1>
          <p className="login-subtitle">Sign in to access your workspace</p>
          <form onSubmit={handleSubmit}>
            <div className="ui-form-group">
              <label htmlFor="email">Email</label>
              <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="you@thevideocompany.in" />
            </div>
            <div className="ui-form-group">
              <label htmlFor="password">Password</label>
              <div className="login-password-wrap">
                <input id="password" type={showPassword ? 'text' : 'password'} value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="Enter password" />
                <button type="button" className="login-password-toggle" onClick={() => setShowPassword(!showPassword)}>
                  <i className={`fas fa-eye${showPassword ? '-slash' : ''}`} />
                </button>
              </div>
            </div>
            <button type="submit" className="ui-btn ui-btn-primary login-submit" disabled={loading}>
              {loading ? 'Signing in…' : 'Sign in'}
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-page-header">
        <Link to="/"><img src={logo} alt="TVC" className="login-page-logo" /></Link>
        <h1>Welcome to TVC</h1>
        <p>Choose your login type to continue</p>
      </div>
      <div className="login-cards">
        <button type="button" className="login-card" onClick={() => setLoginType('admin')}>
          <div className="login-card-icon"><i className="fas fa-shield-alt" /></div>
          <h2>Admin</h2>
          <p>Full access to projects, expenses, invoices, and site management</p>
          <span className="login-card-cta">Admin Login <i className="fas fa-arrow-right" /></span>
        </button>
        <button type="button" className="login-card login-card-employee" onClick={() => setLoginType('employee')}>
          <div className="login-card-icon"><i className="fas fa-user-tie" /></div>
          <h2>Employee</h2>
          <p>Submit and manage your own expenses for active projects</p>
          <span className="login-card-cta">Employee Login <i className="fas fa-arrow-right" /></span>
        </button>
      </div>
      <Link to="/" className="login-home-link"><i className="fas fa-home" /> Back to website</Link>
    </div>
  );
}
